
<template>
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row pt-lg-3">
        </div>

        <div class="row mx-2 pb-3">
          <div class="col-12 d-lg-none mypage-title-row text-center pt-2 pb-2">
            <h4 class="mb-0">{{ $t("message.exam_learning") }} </h4>
          </div>
        </div>
        <div class="row mx-auto">
          <div class="col-12 col-lg-10 mx-auto">
            <p v-show="recruits.length > 0" class="notify-p mb-0"><a href="/recruits" class="notify-p">企業さんから、スカウトが届いています。> 確認する</a></p>
            <div class="row pb-4">
              <div class="col-11 col-lg-11 px-3 py-1 notification-bar mt-4 text-left pb-2 mx-4">
                <span class="pr-2"><b-icon class="h5 mb-0 mt-2 mr-2" icon="question-circle" style='color: gray'></b-icon>現在の状況</span>
                <span class="px-3">|</span>
                <span class="px-3 bar-label">応募中 <span class="px-2 notify-num">{{ meta.applications }}件</span></span>
                <span class="px-2 bar-label">選考中 <span class="px-2 notify-num">{{ meta.selections }}件</span></span>
                <span class="px-2 bar-label">メッセージ <span class="px-2 notify-num">{{ meta.unreads }}件</span></span>
                <span class="px-2 bar-label">選考結果 <span class="px-2 notify-num">{{ meta.results }}件</span></span>

              </div>
            </div>
            <div class="row">
              <div class="col-6 col-lg-23 job-mypage-row-columns px-0 mx-2 pb-3">
                <div class="col-12 pl-2 ">
                  <b-icon class="h4 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.exam_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                </div>
                <router-link :to="'/jobs'">
                  <div class="col-12 text-center pt-0">
                    <b-img class='h60-icon' src="../../../assets/mypage/solve-an-exam_icon.svg"/>
                  </div>
                  <div class="col-12 text-center px-1 py-2">
                    <p class="mb-0 new-text-blue dashboard-menu-text">{{$t("message.search_job")}}</p>
                  </div>
                </router-link>
              </div>
              <div class="col-6 col-lg-23 job-mypage-row-columns px-0 mx-2 pb-3">
                <div class="col-12 pl-2 ">
                  <b-icon class="h4 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.past_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                </div>
                <router-link :to="'/seeker/resume'">
                  <div class="col-12 text-center pt-0">
                    <b-img class='h60-icon' src="../../../assets/mypage/solve-a-past-exam_icon.svg"/>
                  </div>
                  <div class="col-12 text-center px-1 py-2">
                      <p class="mb-0 new-text-blue dashboard-menu-text">あなたの履歴書<br/>編集</p>
                  </div>
                </router-link>
              </div>
              <div class="col-6 col-lg-23 job-mypage-row-columns px-0 mx-2 pb-3">
                <div class="col-12 pl-2">
                  <b-icon class="h4 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.pastexam_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                </div>
                <router-link :to="'/mailbox'">
                  <div class="col-12 text-center pt-0">
                    <b-img class='h60-icon' src="../../../assets/mypage/past-exam-questions.svg"/>
                  </div>
                  <div class="col-12 text-center px-1 py-2">
                    <p class="mb-0 new-text-blue dashboard-menu-text">{{$t("message.chat")}}</p>
                  </div>
                </router-link>
              </div>
              <div class="col-6 col-lg-23 job-mypage-row-columns px-0 mx-2 pb-2">
                <div class="col-12 pl-2">
                  <b-icon class="h4 mb-0 mt-2" @click='showInfoModal("message.title_help", "message.text_menu_help")' icon="question-circle" style='color: gray'></b-icon>
                </div>
                <router-link :to="'/seeker/interview'">
                  <div class="col-12 text-center pt-0">
                    <b-img class='h60-icon' src="../../../assets/mypage/education-materials-download.svg"/>
                  </div>
                  <div class="col-12 text-center px-1 py-2">
                      <p class="mb-0 new-text-blue dashboard-menu-text">面談日程<br/>確認</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <info-modal ref="info"></info-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import InfoModal from "@/components/InfoModal"
export default {
  components: {
    InfoModal
  },
  data () {
    return {
      idToken: localStorage.idToken,
      jobs: [],
      meta: {},
      recruits: [],
    }
  },
  methods: {
    showInfoModal(title='message.sample_title', description='message.sample_description'){
      this.$refs.info.showModal(this.$i18n.t(title), this.$i18n.t(description))
    },
  },
  async mounted() {
    this.$store.commit('setLoading', false)

    axios
      .get(process.env.VUE_APP_API + "/api/seeker/recruits" ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.recruits = response.data.recruits
      }).catch(error => {
        console.log('this is error', error)
      })

    axios
      .get(process.env.VUE_APP_API + "/api/seeker/seekers/1" ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.meta = response.data
      }).catch(error => {
        console.log('this is error', error)
      })
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language,
        outh: state => state.user.outh
    })
  },
  watch:{
    language(){
      this.examination_day = this.$i18n.t('message.no_examination')
    },
  }
}
</script>

<style scoped lang="scss">

.mypage_news-text{
  color: gray;
}

.news-li{
  list-style: none;
  a {
    text-decoration: none;
  }
}

.mb-12{
  margin-bottom: 12px;
}
.more{
  background: #FFFFFF;
  color: gray;
  border: #FFFFFF;
}

.small{
  display:block;
  line-height: 0.85rem;
}

.card{
  border: none;
}

@media (min-width: 991.98px) {
  .col-lg-20 {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .col-lg-23 {
    flex: 0 0 48%;
    max-width: 48%;
  }
}

@media (max-width: 991.98px) {
  .img-caption {
    margin-top: 0px !important;
  }
  .col-lg-23 {
    flex: 0 0 22%;
    max-width: 22%;
  }
  .mt-3 {
    margin-top: 0px !important;
  }
  .line-title {
    font-size: 20px;
  }
  .line-desc {
    font-size: 13px;
  }
  .col-lg-20 {
    position: relative;
    width: 100%;
  }
}
.h60-icon {
  width: 80px;
}
.h40-icon {
  width: 60px;
}
#footer_area{position: fixed;
  bottom:50%;
  right: 1%;
  vertical-align: top;}

@keyframes horizontal {
    0% { transform:translateX( -3px); }
  100% { transform:translateX(  0px); }
}
@keyframes vertical {
    0% { transform:translateY(-10px); }
  100% { transform:translateY(  0px); }
}


.job-side-p {
  font-size: 20px;
  font-weight: bold;
}
.sample-box {
  background-color: #EFEFEF;
  border: 1px solid #CDCDCD;
  height: 150px;
}
.card-border {
  border: 1px solid #C6C6C6;
}
.job-dashboard-title {
  font-size: 20px;
  font-weight: bold;
  color: #4E4E4E;
}
.search-bar {
  background-color: #006FD2;
  border-radius: 15px;
  span {
    color: white;
  }
}
.notification-bar {
  background-color: #fff;
  border-radius: 60px;
  border: 2px solid #D4D4D4;
}
.notify-num {
  color: #F29147;
  font-size: 22px;
  font-weight: 500;
  position: relative;
  top: 2px;
}
.notify-p {
  color: red;
  text-decoration: underline;
  text-align: center;
}
.w100 {
  background-color: #EFEFEF;
  border: 1px solid #CDCDCD;
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.search-select-form {
  width: 20%;
}
.dashboard-menu-text {
  font-size: 20px;
  line-height: 1.5rem;
}



</style>
